import type { HttpsConfig } from '@ms-cloudpack/common-types';
import fs from 'fs';
import { readFile } from 'fs/promises';
import { getCertificatePaths } from './getCertificatePaths.js';
import { defaultPassphrase } from './defaultPassphrase.js';

export async function getCertificate(options: {
  domain?: string | string[];
  passphrase?: string;
  cwd: string;
}): Promise<HttpsConfig | undefined> {
  const { passphrase = defaultPassphrase } = options;
  const { certPath, keyPath } = getCertificatePaths(options);

  // Return undefined if the certs don't exist.
  if (!fs.existsSync(certPath) || !fs.existsSync(keyPath)) {
    return undefined;
  }

  // Read cert/key.
  const [cert, key] = await Promise.all([readFile(certPath), readFile(keyPath)]);

  return {
    cert,
    key,
    passphrase,
  };
}
